module.exports = __webpack_public_path__ + "static/media/sistemaPegar2.c3ee8b8f.jpg";